<div class="info">
    <div *ngIf="label">{{label}}</div>
    <div *ngIf="summary">{{summary}}</div>
</div>
<div class="tooltip-button-container" *ngIf="tooltip">
    <tyt-tooltip-button>
        <button>Learn More</button>
        <div class="popout" [innerHTML]="tooltip | trustHtml"></div>
    </tyt-tooltip-button>
</div>